import {
  FaGithub,
  FaCode,
  FaDatabase,
  FaAward,
  FaHospital,
  FaGraduationCap,
  FaLaptopCode,
  FaCertificate,
  FaCalendarAlt,
  FaRocket,
  FaUsers,
  FaTrophy,
  FaSeedling,
} from 'react-icons/fa';
import {
  SiJavascript,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiGit,
  SiTailwindcss,
  SiPython,
  SiCplusplus,
  SiHtml5,
  SiCss3,
  SiSpringboot,
  SiPostgresql,
  SiRedux,
} from 'react-icons/si';

import hucissaCert from '../images/photo_2025-04-27_06-58-00.jpg';
import zemenayCert from '../images/photo_2025-12-26_18-19-46.jpg';
import mayLogo from '../images/photo_2026-01-28_19-59-49.jpg';
import dsaCert from '../images/photo_2026-03-10_15-55-39.jpg';
import hackathonCert from '../images/photo_2026-04-01_16-11-32.jpg';
import codeAlphaCert from '../images/photo_2026-05-01_09-21-14.jpg';
import codeAlphaRecommendation from '../images/photo_2026-05-03_10-37-30 (2).jpg';
import codeAlphaInternship from '../images/photo_2026-05-03_10-37-30.jpg';
import twoMonthTrainingCert from '../images/photo_2026-05-01_02-04-58.jpg';

export const tagline =
  'Full-Stack Developer & Hackathon Competitor specializing in React, Node.js, MERN stack, and modern mobile-first web applications.';

export const skills = [
  { name: 'React', level: 'Advanced', percent: '85%', icon: <img src={mayLogo} alt="Kenenisa logo" className="skill-logo" />, color: '#61DAFB', category: 'Frontend' },
  { name: 'JavaScript', level: 'Advanced', percent: '80%', icon: <SiJavascript />, color: '#F7DF1E', category: 'Language' },
  { name: 'Node.js', level: 'Advanced', percent: '75%', icon: <SiNodedotjs />, color: '#339933', category: 'Backend' },
  { name: 'Express', level: 'Advanced', percent: '72%', icon: <SiExpress />, color: '#000000', category: 'Backend' },
  { name: 'MySQL', level: 'Advanced', percent: '78%', icon: <SiMysql />, color: '#4479A1', category: 'Database' },
  { name: 'Git/GitHub', level: 'Advanced', percent: '85%', icon: <SiGit />, color: '#F05032', category: 'Tools' },
  { name: 'HTML5', level: 'Advanced', percent: '90%', icon: <SiHtml5 />, color: '#E34F26', category: 'Frontend' },
  { name: 'CSS3', level: 'Advanced', percent: '85%', icon: <SiCss3 />, color: '#1572B6', category: 'Frontend' },
  { name: 'Spring Boot', level: 'Intermediate', percent: '60%', icon: <SiSpringboot />, color: '#6DB33F', category: 'Backend' },
  { name: 'TailwindCSS', level: 'Intermediate', percent: '65%', icon: <SiTailwindcss />, color: '#06B6D4', category: 'Frontend' },
  { name: 'C++', level: 'Intermediate', percent: '60%', icon: <SiCplusplus />, color: '#00599C', category: 'Language' },
  { name: 'MongoDB', level: 'Beginner', percent: '40%', icon: <SiMongodb />, color: '#47A248', category: 'Database' },
  { name: 'PostgreSQL', level: 'Beginner', percent: '35%', icon: <SiPostgresql />, color: '#336791', category: 'Database' },
  { name: 'Python', level: 'Beginner', percent: '45%', icon: <SiPython />, color: '#3776AB', category: 'Language' },
  { name: 'Redux', level: 'Beginner', percent: '30%', icon: <SiRedux />, color: '#764ABC', category: 'Frontend' },
  { name: 'Postman', level: 'Advanced', icon: <FaCode />, color: '#FF6C37', category: 'Tools' },
  { name: 'Vercel/Render', level: 'Advanced', icon: <FaRocket />, color: '#000000', category: 'Tools' },
  { name: 'Figma', level: 'Intermediate', icon: <FaCode />, color: '#F24E1E', category: 'Tools' },
  { name: 'Docker', level: 'Beginner', icon: <FaDatabase />, color: '#2496ED', category: 'Tools' },
];

export const projects = [
  {
    title: 'Voice of HRU — Student Complaint Platform',
    desc: 'A comprehensive feedback and complaint management system for Haramaya University students.',
    link: 'https://github.com/Kenenisaboru/-Student-complain-Voice-of-HRU',
    demo: 'https://student-complain-voice-complain-platform.onrender.com',
    tech: ['MongoDB', 'Express.js', 'React', 'Node.js', 'MERN Stack', 'JWT', 'Redux'],
    type: 'Full-Stack / Hackathon',
    icon: <FaRocket />,
    status: 'Live',
    featured: true,
    highlights: [
      'Hackathon winning project for Haramaya University',
      'Real-time status updates and admin analytics dashboard',
      'Serving 500+ active student feedback requests',
    ],
  },
  {
    title: 'AgriLink — AI-Powered Smart Agriculture',
    desc: 'An intelligent agricultural platform with AI crop disease detection and smart farming insights.',
    link: 'https://github.com/Kenenisaboru/Agrilink',
    demo: 'https://student-complain-voice-complain-platform.onrender.com/',
    tech: ['React', 'Node.js', 'AI/ML', 'Python', 'REST API', 'TailwindCSS'],
    type: 'Full-Stack / AI',
    icon: <FaSeedling />,
    status: 'Live',
    featured: true,
    highlights: [
      'AI-powered crop disease detection and recommendations',
      'Real-time weather integration for farming insights',
      'Designed to empower Ethiopian agricultural communities',
    ],
  },
  {
    title: 'LifeLink — Emergency Healthcare App',
    desc: 'Mobile health application connecting patients rapidly with emergency services and nearby hospitals.',
    link: 'https://github.com/Kenenisaboru',
    tech: ['React Native', 'Node.js', 'Express', 'Geolocation', 'REST API'],
    type: 'Mobile / Hackathon',
    icon: <FaTrophy />,
    status: 'Completed',
    featured: true,
    highlights: [
      'East Ethiopian Cursor Hackathon top 10 finalist',
      'Real-time emergency dispatch tracking',
      'Mobile-first responsive architecture',
    ],
  },
  {
    title: 'Hospital Management System',
    desc: 'Full-stack hospital management with patient records, scheduling, and billing integration.',
    link: 'https://github.com/Kenenisaboru/Hospital-management-system',
    tech: ['React', 'Node.js', 'Express', 'MySQL', 'REST API', 'JWT', 'Redux'],
    type: 'Full-Stack',
    icon: <FaHospital />,
    status: 'Completed',
    featured: true,
    highlights: [
      'Secure multi-role authentication (Admin, Doctor, Patient)',
      'Optimized MySQL relational database schema',
      'Built for enterprise healthcare workflows',
    ],
  },
  {
    title: 'Aseko Students Platform — Community Hub',
    desc: 'Cross-platform PWA networking solution for students from Arsi Aseko.',
    link: 'https://github.com/Kenenisaboru/student-platform',
    tech: ['React', 'Firebase', 'PWA', 'Tailwind CSS', 'Real-time Chat'],
    type: 'Full-Stack / PWA',
    icon: <FaUsers />,
    status: 'Live',
    highlights: [
      'Connecting 300+ students across universities',
      'PWA caching for offline accessibility',
      'Cross-platform on mobile and desktop',
    ],
  },
  {
    title: 'Frontend Tricks Collection',
    desc: 'Collection of modern frontend techniques, animations, and responsive layout patterns.',
    link: 'https://github.com/Kenenisaboru/All-my-frontend-trick',
    tech: ['HTML5', 'CSS3', 'JavaScript', 'GSAP', 'Animations'],
    type: 'Frontend',
    icon: <FaLaptopCode />,
    status: 'Ongoing',
    highlights: ['Reusable animated components', 'Performance optimizations', 'CSS Grid and Flexbox patterns'],
  },
  {
    title: 'Data Structure & Algorithm Library',
    desc: 'C++ library implementing essential data structures, sorting algorithms, and graph traversals.',
    link: 'https://github.com/Kenenisaboru/Data-structure-and-Algorithm',
    tech: ['C++', 'STL', 'Algorithms', 'Data Structures'],
    type: 'Algorithm',
    icon: <FaGraduationCap />,
    status: 'Completed',
    highlights: ['Performance benchmark tests', 'Algorithm documentation', 'Optimized time complexity'],
  },
];

export const featuredRepositories = [
  {
    title: 'Voice of HRU — Student Complaint Platform',
    description: 'Feedback management system built with MERN stack and Socket.io for real-time admin updates.',
    link: 'https://github.com/Kenenisaboru/-Student-complain-Voice-of-HRU',
    contributions: [
      'Built full-stack React and Node.js architecture with JWT authentication',
      'Integrated Socket.io for real-time notification dispatch',
      'Deployed live application serving 500+ active students',
    ],
    tech: ['React', 'Node.js', 'Express', 'MongoDB', 'Socket.io', 'JWT'],
  },
  {
    title: 'Hospital Management System',
    description: 'Enterprise hospital administration with patient records and role-based access control.',
    link: 'https://github.com/Kenenisaboru/Hospital-management-system',
    contributions: [
      'Designed normalized MySQL database schema',
      'Implemented secure multi-role auth (Admin, Doctor, Patient)',
      'Created responsive dashboard interface using React',
    ],
    tech: ['React', 'Node.js', 'Express', 'MySQL', 'REST API', 'Redux'],
  },
  {
    title: 'Aseko Students Platform — Community Hub',
    description: 'Cross-platform PWA connecting 300+ students for resource sharing and communication.',
    link: 'https://github.com/Kenenisaboru/student-platform',
    contributions: [
      'Built Progressive Web App supporting offline access',
      'Integrated Firebase real-time chat and document sharing',
      'Designed mobile-first UI with Tailwind CSS',
    ],
    tech: ['React', 'Firebase', 'PWA', 'Tailwind CSS'],
  },
  {
    title: 'Frontend Tricks Collection',
    description: 'Library of advanced CSS/JS UI components, micro-animations, and responsive patterns.',
    link: 'https://github.com/Kenenisaboru/All-my-frontend-trick',
    contributions: [
      'Implemented reusable interactive UI animation snippets',
      'Optimized CSS rendering and responsive breakpoints',
      'Documented clean code patterns for modern web development',
    ],
    tech: ['HTML5', 'CSS3', 'JavaScript', 'GSAP'],
  },
  {
    title: 'Data Structure & Algorithm Library',
    description: 'High-performance C++ algorithms and data structures with unit tests.',
    link: 'https://github.com/Kenenisaboru/Data-structure-and-Algorithm',
    contributions: [
      'Implemented graph traversals, sorting, and tree algorithms',
      'Wrote unit test suite and time-complexity documentation',
      'Benchmarked algorithmic efficiency',
    ],
    tech: ['C++', 'Algorithms', 'Data Structures', 'STL'],
  },
];

export const awards = [
  {
    title: 'Best Hackathons Competitor',
    org: 'Haramaya University Hackathon — 2026',
    desc: 'Recognized as the best competitor for building an innovative student feedback management system.',
    icon: <FaAward />,
    image: null,
    type: 'hackathon',
    date: 'April 2026',
    verification: 'https://student-complain-voice-complain-platform.onrender.com',
    skills: ['MERN Stack', 'Problem Solving', 'UI/UX Design', 'Full-Stack Development'],
  },
  {
    title: 'In-Depth Data Structure & Algorithm',
    org: 'Intensive Training Program — 2026',
    desc: 'Completed 45 days of intensive training in advanced data structures and algorithmic problem-solving.',
    icon: <FaGraduationCap />,
    image: dsaCert,
    type: 'certificate',
    date: 'April 2026',
    verification: '#',
    skills: ['JavaScript', 'Data Structures', 'Algorithms', 'Optimization'],
  },
  {
    title: 'East Ethiopian Cursor Hackathon Finalist',
    org: 'East Ethiopian Hackathon — 2026',
    desc: 'Top 6 finalist for building LifeLink, an innovative mobile application solution.',
    icon: <FaAward />,
    image: hackathonCert,
    type: 'hackathon',
    date: 'April 2026',
    verification: '#',
    skills: ['Mobile Development', 'React Native', 'Problem Solving'],
  },
  {
    title: 'Full-Stack Web Development Intern',
    org: 'CodeAlpha — 2026',
    desc: 'Remote internship focusing on real-world web applications and modern full-stack frameworks.',
    icon: <FaLaptopCode />,
    image: codeAlphaCert,
    type: 'internship',
    date: 'May 2026',
    verification: '#',
    skills: ['React', 'Node.js', 'Team Collaboration', 'Full-Stack Development'],
  },
  {
    title: 'CodeAlpha Internship Certificate',
    org: 'CodeAlpha — 2026',
    desc: 'Official internship completion certificate after delivering multiple full-stack projects.',
    icon: <FaCertificate />,
    image: codeAlphaInternship,
    type: 'internship',
    date: 'May 2026',
    verification: '#',
    skills: ['Full-Stack Development', 'React', 'Node.js', 'Professional Growth'],
  },
  {
    title: 'CodeAlpha Letter of Recommendation',
    org: 'CodeAlpha — 2026',
    desc: 'Letter of recommendation recognizing exceptional performance and technical excellence.',
    icon: <FaAward />,
    image: codeAlphaRecommendation,
    type: 'internship',
    date: 'May 2026',
    verification: '#',
    skills: ['Leadership', 'Technical Excellence', 'Professional Development'],
  },
  {
    title: 'Web Development Excellence Award',
    org: 'HUCCISA — 2024',
    desc: 'Recognized for outstanding performance and innovation in modern web development.',
    icon: <FaCertificate />,
    image: hucissaCert,
    type: 'certificate',
    date: 'December 2024',
    verification: '#',
    skills: ['React', 'Node.js', 'Full-Stack Development'],
  },
  {
    title: 'Hackathon Participant - Finance App',
    org: 'Zemenay Hackathon — 2025',
    desc: 'Best competitor in a finance app hackathon.',
    icon: <FaAward />,
    image: zemenayCert,
    type: 'hackathon',
    date: 'September 2025',
    verification: '#',
  },
  {
    title: 'Frontend Development Certification',
    org: 'freeCodeCamp — 2024',
    desc: 'Certified Frontend Developer with projects in responsive design and JavaScript.',
    icon: <FaCode />,
    image: null,
    type: 'certificate',
    date: 'November 2024',
    verification: 'https://freecodecamp.org/certification',
    skills: ['Responsive Design', 'JavaScript', 'Web Accessibility'],
  },
  {
    title: 'Introduction to Web Development',
    org: 'HUCCISA — 2025',
    desc: 'Intensive web development course covering HTML5, CSS3, and JavaScript.',
    icon: <FaCertificate />,
    image: hucissaCert,
    type: 'certificate',
    date: 'July 2025',
    verification: '#',
    skills: ['HTML5', 'CSS3', 'JavaScript Basics'],
  },
  {
    title: 'Two-Month Intensive Training Certificate',
    org: 'Professional Training Program — 2026',
    desc: 'Completed a rigorous two-month intensive training program with official certification.',
    icon: <FaGraduationCap />,
    image: twoMonthTrainingCert,
    type: 'certificate',
    date: 'May 2026',
    verification: '#',
    skills: ['Professional Development', 'Technical Training', 'Certification'],
  },
];

export const stats = [
  { label: 'Projects Completed', value: '40+', icon: <FaRocket /> },
  { label: 'Years Experience', value: '2+', icon: <FaCalendarAlt /> },
  { label: 'Technologies', value: '12+', icon: <FaCode /> },
  { label: 'GitHub Repositories', value: '50+', icon: <FaGithub /> },
  { label: 'Code Commits', value: '2250+', icon: <FaDatabase /> },
  { label: 'Certifications', value: '10+', icon: <FaCertificate /> },
];

export const personalInfo = {
  location: 'Haramaya University, Harar',
  availability: 'Available for full-time & freelance',
  experience: '2+ years in web development',
  education: 'BSc in Information Science',
};
